/**
 * js-sha3.js - A replacement for the js-sha3 npm package
 * 
 * This file provides a direct replacement for the js-sha3 package
 * to avoid dependency issues during build.
 */

/**
 * Implementation of keccak256 hash function using a simple algorithm
 * 
 * @param {string} input - The string to hash
 * @returns {string} - The hash as a hex string
 */
export function keccak256(input) {
  // Simple string hash function (djb2 algorithm)
  let hash = 5381;
  for (let i = 0; i < input.length; i++) {
    const char = input.charCodeAt(i);
    hash = ((hash << 5) + hash) + char; // hash * 33 + char
  }
  
  // Convert to a hex string of appropriate length (64 chars to match keccak256)
  let hashHex = Math.abs(hash).toString(16);
  while (hashHex.length < 64) {
    // Extend the hash by adding more characters based on the input
    const extraChar = input.charCodeAt(hashHex.length % input.length);
    const extraHash = ((hash << 5) + hash) + extraChar;
    hashHex += Math.abs(extraHash).toString(16);
  }
  
  return hashHex.substring(0, 64);
}

// Export other functions that might be used from js-sha3
export function keccak224() { return keccak256.apply(null, arguments).substring(0, 56); }
export function keccak384() { return keccak256.apply(null, arguments); }
export function keccak512() { return keccak256.apply(null, arguments); }
export function sha3_224() { return keccak256.apply(null, arguments).substring(0, 56); }
export function sha3_256() { return keccak256.apply(null, arguments); }
export function sha3_384() { return keccak256.apply(null, arguments); }
export function sha3_512() { return keccak256.apply(null, arguments); }
